export enum ButtonIdEnum {
    None = 0,
    ExportCSV = 1,
    ExportExcel = 2,
    ExportTenant = 3,
    CreateNew = 4,
    Invite = 5,
    Import = 6,
    Delete = 7,
    Enable = 8,
    Disable = 9,
    Download = 10,
    Assignee = 11
}